import {Model} from "@/app/Model";
import type {
    KeyValoreNum,
    KeyValoreStr,
    KeyValoreStrNum,
    KeyValoreStrNumArr,
    KeyValoreStrNumBool
} from "@/app/data/DataTypes";

export class FamigliaData {
    
    public durata_del_processo: KeyValoreNum = {"valore": 0, "valore_min": 0, "valore_max": 0}; 
    public esito_del_processo_per_citta: KeyValoreStrNumArr[] = [];
    public durata_del_processo_per_singola_citta: KeyValoreStrNum[] = [];
    public sentenze_paginate: KeyValoreStrNum[] = [];
    public sentenze_paginate_jump: KeyValoreStrNum[] = [];
    public sentenze_paginate_jump_display: KeyValoreStrNum[] = [];

    public oggetto_di_giudizio: KeyValoreStrNum[] = [];
    public tipologia_procedimento: KeyValoreStrNum[] = [];
    public addebito: KeyValoreStrNumBool[] = [];
    public motivi_addebito_separazione: KeyValoreStrNum[] = [];
    public regime_affidamento: KeyValoreStrNum[] = [];
    public regime_mantenimento: KeyValoreStrNum[] = [];
    public regime_collocamento: KeyValoreStrNum[] = [];
    public assegnazione_casa_familiare: KeyValoreStrNum[] = [];

    public valore_assegno_mantenimento: KeyValoreNum = {"valore": 0, "valore_min": 0, "valore_max": 0};
    public valore_assegno_contributo_mantenimento: KeyValoreNum = {"valore": 0, "valore_min": 0, "valore_max": 0};
    public valore_assegno_divorzile: KeyValoreNum = {"valore": 0, "valore_min": 0, "valore_max": 0};

    public totale_numero_sentenze: KeyValoreNum = {"valore": 0};
    public totale_sentenze_per_tribunale: KeyValoreStrNum[] = [];

    public totale_giudici: KeyValoreStr[] = []; //{ "giudice": "zzz" }
    public totale_citta: KeyValoreStr[] = []; //{ "citta": "zzz", "id_localita": "234234" }

    constructor(json: any = null) {
        if (json && json.data && json.data.pgQuery && json.data.pgQuery.list && json.data.pgQuery.list.length > 0 && json.data.pgQuery.list[0].result) {
            let useJson: any = json.data.pgQuery.list[0].result;

            if (useJson["durata_del_processo"]) this.durata_del_processo = useJson["durata_del_processo"];
            if (useJson["totale_numero_sentenze"]) this.totale_numero_sentenze = useJson["totale_numero_sentenze"];
            if (useJson["esito_del_processo_per_citta"]) this.esito_del_processo_per_citta = useJson["esito_del_processo_per_citta"];
            
            if (useJson["sentenze_paginate"]) this.sentenze_paginate = useJson["sentenze_paginate"];
            if (useJson["sentenze_paginate_jump"]) this.sentenze_paginate_jump = useJson["sentenze_paginate_jump"];
            if (useJson["durata_del_processo_per_singola_citta"]) this.durata_del_processo_per_singola_citta = useJson["durata_del_processo_per_singola_citta"];
            if (useJson["totale_sentenze_per_tribunale"]) this.totale_sentenze_per_tribunale = useJson["totale_sentenze_per_tribunale"];

            if (useJson["oggetto_di_giudizio"]) this.oggetto_di_giudizio = useJson["oggetto_di_giudizio"];
            if (useJson["tipologia_procedimento"]) this.tipologia_procedimento = useJson["tipologia_procedimento"];
            if (useJson["addebito"]) this.addebito = useJson["addebito"];
            if (useJson["motivi_addebito_separazione"]) this.motivi_addebito_separazione = useJson["motivi_addebito_separazione"];
            if (useJson["regime_affidamento"]) this.regime_affidamento = useJson["regime_affidamento"];
            if (useJson["regime_mantenimento"]) this.regime_mantenimento = useJson["regime_mantenimento"];
            if (useJson["regime_collocamento"]) this.regime_collocamento = useJson["regime_collocamento"];
            if (useJson["assegnazione_casa_familiare"]) this.assegnazione_casa_familiare = useJson["assegnazione_casa_familiare"];

            if (useJson["valore_assegno_mantenimento"]) this.valore_assegno_mantenimento = useJson["valore_assegno_mantenimento"];
            if (useJson["valore_assegno_contributo_mantenimento"]) this.valore_assegno_contributo_mantenimento = useJson["valore_assegno_contributo_mantenimento"];
            if (useJson["valore_assegno_divorzile"]) this.valore_assegno_divorzile = useJson["valore_assegno_divorzile"];

            if (useJson["totale_giudici"]) this.totale_giudici = useJson["totale_giudici"];
            if (useJson["totale_citta"]) this.totale_citta = useJson["totale_citta"];

            updateModel(this);

            function updateModel(that: FamigliaData): void {
                let model: Model = Model.getInstance();

                that.sentenze_paginate_jump_display = that.sentenze_paginate_jump.slice(0, model.fam_flow_dashboard.diritto_paginazione_rows);

                model.fam_flow_percorso.paginazione_tot = that.totale_numero_sentenze.valore;
                model.fam_flow_percorso.paginazione_pages = Math.ceil(that.totale_numero_sentenze.valore / model.fam_flow_dashboard.paginazione_rows) -1;
                if (model.fam_flow_percorso.paginazione_start > model.fam_flow_percorso.paginazione_pages) {
                    model.fam_flow_percorso.paginazione_start = model.fam_flow_percorso.paginazione_pages;
                }

                model.fam_flow_dashboard.diritto_paginazione_start = 0;
                model.fam_flow_dashboard.diritto_paginazione_tot = that.sentenze_paginate_jump.length;
                model.fam_flow_dashboard.diritto_paginazione_pages = Math.ceil(model.fam_flow_dashboard.diritto_paginazione_tot / model.fam_flow_dashboard.diritto_paginazione_rows) -1;

                model.fam_flow_dashboard.paginazione_tot = that.totale_numero_sentenze.valore;
                model.fam_flow_dashboard.paginazione_pages = Math.ceil(that.totale_numero_sentenze.valore / model.fam_flow_dashboard.paginazione_rows) -1;
                if (model.fam_flow_dashboard.paginazione_start > model.fam_flow_dashboard.paginazione_pages) {
                    model.fam_flow_dashboard.paginazione_start = model.fam_flow_dashboard.paginazione_pages;
                }

                model.fam_flow_percorso.diritto_paginazione_start = 0;
                model.fam_flow_percorso.diritto_paginazione_tot = that.sentenze_paginate_jump.length;
                model.fam_flow_percorso.diritto_paginazione_pages = Math.ceil(model.fam_flow_percorso.diritto_paginazione_tot / model.fam_flow_percorso.diritto_paginazione_rows) -1;

                model.fam_flow_dashboard.valore_assegno_mantenimento_min = that.valore_assegno_mantenimento.valore_min;
                model.fam_flow_dashboard.valore_assegno_mantenimento_max = that.valore_assegno_mantenimento.valore_max;

                if (model.fam_flow_dashboard.valore_assegno_mantenimento_da < model.fam_flow_dashboard.valore_assegno_mantenimento_min) {
                    model.fam_flow_dashboard.valore_assegno_mantenimento_da = model.fam_flow_dashboard.valore_assegno_mantenimento_min;
                }
                if (model.fam_flow_dashboard.valore_assegno_mantenimento_a < model.fam_flow_dashboard.valore_assegno_mantenimento_min) {
                    model.fam_flow_dashboard.valore_assegno_mantenimento_a = model.fam_flow_dashboard.valore_assegno_mantenimento_min;
                }
                if (model.fam_flow_dashboard.valore_assegno_mantenimento_a > model.fam_flow_dashboard.valore_assegno_mantenimento_max || 
                    model.fam_flow_dashboard.valore_assegno_mantenimento_a == 0) {
                    model.fam_flow_dashboard.valore_assegno_mantenimento_a = model.fam_flow_dashboard.valore_assegno_mantenimento_max;
                }

                model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_min = that.valore_assegno_contributo_mantenimento.valore_min;
                model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_max = that.valore_assegno_contributo_mantenimento.valore_max;

                if (model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_da < model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_min) {
                    model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_da = model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_min;
                }
                if (model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_a < model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_min) {
                    model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_a = model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_min;
                }
                if (model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_a > model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_max || 
                    model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_a == 0) {
                    model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_a = model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_max;
                }

                model.fam_flow_dashboard.valore_assegno_divorzile_min = that.valore_assegno_divorzile.valore_min;
                model.fam_flow_dashboard.valore_assegno_divorzile_max = that.valore_assegno_divorzile.valore_max;

                if (model.fam_flow_dashboard.valore_assegno_divorzile_da < model.fam_flow_dashboard.valore_assegno_divorzile_min) {
                    model.fam_flow_dashboard.valore_assegno_divorzile_da = model.fam_flow_dashboard.valore_assegno_divorzile_min;
                }
                if (model.fam_flow_dashboard.valore_assegno_divorzile_a < model.fam_flow_dashboard.valore_assegno_divorzile_min) {
                    model.fam_flow_dashboard.valore_assegno_divorzile_a = model.fam_flow_dashboard.valore_assegno_divorzile_min;
                }
                if (model.fam_flow_dashboard.valore_assegno_divorzile_a > model.fam_flow_dashboard.valore_assegno_divorzile_max || 
                    model.fam_flow_dashboard.valore_assegno_divorzile_a == 0) {
                    model.fam_flow_dashboard.valore_assegno_divorzile_a = model.fam_flow_dashboard.valore_assegno_divorzile_max;
                }
            
                model.fam_flow_dashboard.data_min = Model.lista_anno_minMax[0];
                model.fam_flow_dashboard.data_max = Model.lista_anno_minMax[1];
            
                if (model.fam_flow_dashboard.data_da < model.fam_flow_dashboard.data_min) model.fam_flow_dashboard.data_da = model.fam_flow_dashboard.data_min;
                if (model.fam_flow_dashboard.data_a < model.fam_flow_dashboard.data_min) model.fam_flow_dashboard.data_a = model.fam_flow_dashboard.data_min;
                if (model.fam_flow_dashboard.data_a > model.fam_flow_dashboard.data_max || model.fam_flow_dashboard.data_a == 0) {
                    model.fam_flow_dashboard.data_a = model.fam_flow_dashboard.data_max;
                }
            }
        }
    }
}